import React from "react"
import PropTypes from "prop-types"
import { Box } from "rebass"

import theme from "../../../theme"

const Container = (props) => {
  const { children, fluid, tag } = props;

  // todo : responsive padding needed ?
  const padding = () => {
    return fluid ? 0 : [2, 4]
  }

  // responsive width
  const width = () => {
    return fluid
      ? `100%`
      : [
          `100%`,
          `100%`,
          theme.breakpoints[1],
          theme.breakpoints[2],
          theme.breakpoints[3],
          theme.breakpoints[4],
        ]
  }

  return (
    <Box as={tag} {...props} color={props.textColor ? props.textColor : 'inherit'} px={padding()} mx={`auto`} width={width()}>
      {children}
    </Box>
  )
}

Container.propTypes = {
  fluid: PropTypes.bool,
  tag: PropTypes.string,
}

Container.defaultProps = {
  fluid: false,
  tag: 'section',
}

export default Container
